export default __webpack_public_path__ + "static/media/Talons of Black Oblivion.9b32d02f.jpg";